import styles from './style.module.scss';
import React from 'react';
import PageHeading from '../../components/PageHeading';
import { Link } from 'react-router-dom';

/**
 * NotFoundPage component:
 * It is a default landing page for all the unregistered routes showing that
 * the user has requested for a page that doesn't exist.
 */
export default function NotFoundPage() {
  return (
    <div className="container">
      <div className="bg-white rounded-15 shadow-sm px-3">
        <div className="text-center py-4">
          <div className="display-3 fw-bold">404</div>
          <div className="fs-4 fw-bold">Page Not Found</div>
          <br />
          <Link to={'/'} className="fs-5 fw-bold link-primary">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
